<template>
  <a
    class="block text-center active:opacity-70"
    :href="localePath({ name: 'order-product-product', params: { product: item.no } })"
    @click.prevent="show(item)"
  >
    <div class="relative mb-1.5 aspect-square overflow-hidden rounded-lg bg-gray-50 p-1">
      <img
        v-if="index >= 0 && index < 4"
        :src="cdnImage(item.image || '/imgs/no_photo.jpg', 256)"
        :alt="item.name"
        width="256"
        height="256"
        class="w-full h-full object-contain mix-blend-multiply"
        loading="eager"
        :fetchpriority="index === 0 ? 'high' : 'auto'"
        @error="useFallbackImage"
      />
      <img
        v-else
        :src="cdnImage(item.image || '/imgs/no_photo.jpg', 256)"
        :alt="item.name"
        width="256"
        height="256"
        class="w-full h-full object-contain mix-blend-multiply"
        v-lazy-load
        loading="lazy"
        @error="useFallbackImage"
      />
    </div>
    <div v-if="hasCaption" class="px-0.5">
      <p
        class="line-clamp-2 break-all text-[10px] font-medium leading-tight text-gray-700 sm:text-[11px]"
      >
        {{ item.name }}
      </p>
      <p class="mt-1 text-[10px] font-semibold text-primary" v-if="startingPrice">
        {{ currency }} {{ startingPrice | number_format }} 起
      </p>
    </div>
  </a>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    item: Object,
    index: {
      type: Number,
      default: -1,
    },
    hasCaption: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    ...mapActions({
      fetch: "cart/fetch",
      popupShow: "popup/show",
    }),

    show(item) {
      if (this.$track) {
        this.$track.selectItem(item, {
          id:
            this.$route.query.category ||
            this.$route.query.catalog ||
            this.$route.query.keywords ||
            "all",
          name: this.$route.query.title || "全部商品",
          index: this.index,
        });
      }
      this.popupShow({
        el: "Specification",
        data: { item },
      });
    },

    async addToOrder() {
      if (!this.item.buyable) return false;
      if (this.isGuest()) return;
      try {
        await this.$axios.post("/api/cart", {
          product: this.item.id,
          variations: [],
          quantity: 1,
        });
        if (this.$track) {
          this.$track.addToCart(this.item, null, 1);
        }
        this.fetch();
        this.$loader.success("已加入購物車");
      } catch (e) {
        this.handleErrorsMessage(e);
      }
    },
    add() {
      if (this.item.once_for_each_only) return this.show(this.item);

      this.addToOrder();
    },
    useFallbackImage(event) {
      event.target.onerror = null;
      event.target.src = "/imgs/no_photo.jpg";
    },
  },
  computed: {
    startingPrice() {
      if (!this.item.products || !this.item.products.length) return null;
      const prices = this.item.products.map((p) => Number(p.discount || p.price));
      return Math.min(...prices);
    },
  },
};
</script>

<style scoped>
.min-h-65px {
  min-height: 65px;
}
</style>
